"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PRO_VALIDATION_ERROR_TYPES = exports.CLIENT_NAMES = exports.normalizeScannedProNumber = exports.getProScanHelperLabel = exports.getProInputHelperLabel = exports.getProNumberValidationFunctions = void 0;
const BaseProNumberValidator_1 = __importDefault(require("./common/BaseProNumberValidator"));
const BaseProNumberWithCheckDigit_1 = __importDefault(require("./common/BaseProNumberWithCheckDigit"));
const BaseProCheckDigit_1 = __importDefault(require("./common/BaseProCheckDigit"));
const strategies_1 = require("./strategies");
const constants_1 = require("./constants");
Object.defineProperty(exports, "CLIENT_NAMES", { enumerable: true, get: function () { return constants_1.CLIENT_NAMES; } });
Object.defineProperty(exports, "PRO_VALIDATION_ERROR_TYPES", { enumerable: true, get: function () { return constants_1.PRO_VALIDATION_ERROR_TYPES; } });
const getProNumberValidationFunctions = ({ clientName, enableCheckDigit = false, proNumberLengthConstraints, metaData = {}, }) => {
    const options = {
        enableCheckDigit,
        proNumberLengthConstraints,
        metaData,
    };
    const strategy = getStrategy(clientName, options);
    return {
        validateProNumber: (0, BaseProNumberValidator_1.default)(strategy),
        getProNumberWithCheckDigit: (0, BaseProNumberWithCheckDigit_1.default)(strategy),
        getCheckDigit: (0, BaseProCheckDigit_1.default)(strategy),
        isTempProNumber: strategy.isTempProNumber,
    };
};
exports.getProNumberValidationFunctions = getProNumberValidationFunctions;
const getProInputHelperLabel = (clientName) => {
    if (clientName === constants_1.CLIENT_NAMES.SEFL) {
        return constants_1.PRO_INPUT_HELPER_LABELS.SEFL;
    }
    return constants_1.PRO_INPUT_HELPER_LABELS.DEFAULT;
};
exports.getProInputHelperLabel = getProInputHelperLabel;
const getProScanHelperLabel = (clientName) => {
    if (clientName === constants_1.CLIENT_NAMES.SEFL) {
        return constants_1.PRO_SCAN_HELPER_LABELS.SEFL;
    }
    return constants_1.PRO_SCAN_HELPER_LABELS.DEFAULT;
};
exports.getProScanHelperLabel = getProScanHelperLabel;
const normalizeScannedProNumber = (clientName, hasCheckDigit, cleanedNumericPro, proNumberMaxLength) => {
    if (clientName !== constants_1.CLIENT_NAMES.SEFL &&
        hasCheckDigit &&
        cleanedNumericPro.length > proNumberMaxLength - 1) {
        return cleanedNumericPro.slice(0, proNumberMaxLength - 1);
    }
    return cleanedNumericPro;
};
exports.normalizeScannedProNumber = normalizeScannedProNumber;
const getStrategy = (clientName, options) => {
    switch (clientName) {
        case constants_1.CLIENT_NAMES.SAIA:
            return (0, strategies_1.createSaiaStrategy)(options);
        case constants_1.CLIENT_NAMES.ESTES:
            return (0, strategies_1.createEstesStrategy)(options);
        case constants_1.CLIENT_NAMES.SEFL:
            return (0, strategies_1.createSeflStrategy)(options);
        case constants_1.CLIENT_NAMES.TSTCF:
            return (0, strategies_1.createTstcfStrategy)(options);
        case constants_1.CLIENT_NAMES.TFRC:
            return (0, strategies_1.createTfrcStrategy)(options);
        default:
            return (0, strategies_1.createDefaultStrategy)(options);
    }
};
